<template>
	<el-card shadow="never" class="aui-card--fill transaction-record-page">
    <el-row style="padding-bottom: 0 !important;">
			<el-col :xs="6" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;"
					src="../../../assets/img/wofangxinxi-icon.png" />
				交易记录
			</el-col>
		<!-- </el-row> -->
		<!-- <el-row style="background-color: #F3F4F4;"> -->
			<el-col :xs="18" :md="18" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;display:flex;align-items: center;justify-content: flex-end;">
				
			<!-- </el-col>
			<el-col :xs="24" :md="12"> -->
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="padding-bottom: 0 !important;">
					<!-- <el-form-item v-if="$hasPermission('plat:plattransaction:account')&& rolePermissions == 'COMPANY'">
						<div style="font-size: 16px;font-weight: bold;color: #111111;">账户余额：{{infodata.balance}}</div>
					</el-form-item> -->
					<el-form-item style="margin-bottom:0 !important;line-height: 30px !important;">
						<el-button type="primary"
							v-if="infodata.showPayPassBtn && $hasPermission('plat:plattransactiondetais:jypwd') && infodata.hasSetPayPass==false"
							@click="setpwd(0)">设置支付密码</el-button>
						<el-button type="primary"
							v-if="infodata.showPayPassBtn && $hasPermission('plat:plattransactiondetais:jypwd') && infodata.hasSetPayPass==true"
							@click="setpwd(1)">修改支付密码</el-button>
					</el-form-item>
				</el-form>
				<el-form :inline="true" style="text-align: right;padding-bottom: 0 !important;line-height: 30px !important;" :model="dataForm"
					@keyup.enter.native="getDataList()">
					<el-form-item style="margin-bottom:0 !important;">
						<el-button type="primary" @click="exportHandle()">{{ $t('export') }}</el-button>
					</el-form-item>
					<el-form-item style="margin-bottom:0 !important;">
						<el-button type="info" @click="getDataList()">刷新</el-button>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>

    
		<el-row style="background-color: #fff;">
			<el-form label-width="140px" style="padding:10px 5px 0px;" ref="dataForm" :model="dataForm" @keyup.enter.native="getDataList()">
				<!--<el-form-item label="我方主体名称:"  v-if="$hasPermission('plat:plattransactiondetais:zhuti')">-->
					<!--<el-select  v-model="dataForm.bodyName" placeholder="请输入名称" clearable>-->
						<!--<el-option v-for="platBody in platBodyList" :key="platBody.id" :label="platBody.bodyName"-->
								   <!--:value="platBody.bodyName"></el-option>-->
					<!--</el-select>-->
				<!--</el-form-item>-->
        <el-row>
          <el-col :md="8" :lg="8">
            <el-form-item label="收款方:">
              <el-input  v-model="dataForm.payeeAccountTitle" placeholder="收款方" clearable style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="8">
            <el-form-item label="收款方银行账号:">
              <el-input  v-model="dataForm.payeeBankAccount" placeholder="收款方银行账号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="8">
            <el-form-item label="任务大类" prop="taskType">
              <!-- <ren-select v-model="dataForm.taskType" dict-type="taskType" style="width:100%"></ren-select> -->
              <el-select style="width: 100%;" v-model="dataForm.taskType" placeholder="请选择任务大类" clearable filterable>
                <el-option
                        v-for="item in taskList"
                        :key="item.ticketProId"
                        :value="item.ticketProject"
                ></el-option>
            </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="8">
            <el-form-item label="身份证号码:">
              <el-input  v-model="dataForm.idCard" placeholder="身份证号码" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="8">
            <el-form-item label="手机号:">
              <el-input  v-model="dataForm.phone" placeholder="手机号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="8">
            <el-form-item label="业务类型:">
              <el-select v-model="dataForm.type" placeholder="请选择类型"  clearable filterable  style="width:100%">
                <el-option v-for="item in businessTypeOptions" :key="item.value" :label="item.label" :value="item.value" 
                      :disabled="item.disabled"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="8" class="timeSty">
            <el-form-item  label="操作时间:">
                <el-date-picker v-model="dataForm.startDate"
                        style="width: 48%"
                        :picker-options='pickerStartOptions(dataForm.endDate)'
                        type="date"
                        placeholder="开始日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"   />
                <span style="width:4%;text-align: center;display: inline-block;">~</span>
                <el-date-picker v-model="dataForm.endDate"
                      :picker-options='pickerEndOptions(dataForm.startDate)'
                        style="width: 48%"
                        type="date"
                        placeholder="结束日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"   />
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="8">
            <el-form-item label="税源地:" prop="bodyId">
              <el-select v-model="dataForm.bodyId" placeholder="请选择" style="width:100%" clearable filterable>
              <el-option
                v-for="item in bodyPageList"
                :key="item.id"
                :label="`${item.bodyName}-${item.abbreviation}`"
                :value="item.id">
              </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          
          <el-col :md="8" :lg="8">
            <el-form-item style="text-align:right">
              <el-button type="primary" @click="getDataList()">{{ $t('query') }}</el-button>
              <el-button type="primary" @click="regiestDataList()">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
				
				
        
        
        
        
        
				
				<!--<el-form-item >-->
					<!--<el-select v-model="dataForm.timeSlot" placeholder="请选择" @change="updateByTimeSlot" clearable>-->
						<!--<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"-->
								   <!--:disabled="item.disabled"></el-option>-->
					<!--</el-select>-->
				<!--</el-form-item>-->
				
				
			</el-form>

		</el-row>


		
		<div class="table-container">
      <el-table ref="refTable" v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle"
        style="width: 100%;" height="500">
				<el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
				<el-table-column label="序号" type="index" width="50" align="center">
					<template slot-scope="scope">
						<span>{{ (page - 1) * limit + scope.$index + 1 }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="payeeAccountTitle" label="收款方" header-align="center" align="center">
				</el-table-column>
		  <el-table-column prop="abbreviation" label="税源地简称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="idCard" label="身份证号码" header-align="center" align="center">
				</el-table-column>
        <el-table-column prop="phone"  label="手机号" header-align="center" align="center">
				</el-table-column>
				<el-table-column prop="payeeBankAccount" label="收款方银行账号/子账号" header-align="center" align="center">
				</el-table-column>
				<el-table-column prop="summary" label="摘要" header-align="center" align="center"></el-table-column>
				<el-table-column prop="businessType" :formatter="businessType" label="业务类型" header-align="center" align="center">
				</el-table-column>
        <el-table-column prop="taskTypeName"  label="任务大类" header-align="center" align="center">
				</el-table-column>
        
				<el-table-column prop="payerAccountTitle" label="任务发布方" header-align="center" align="center">
				</el-table-column>
				<el-table-column prop="payerBankAccount" label="发布方子账号" header-align="center" align="center">
				</el-table-column>
				<el-table-column prop="amount" label="金额" header-align="center" align="center">
				</el-table-column>
        <el-table-column prop="sourceOrg" label="来源企业" header-align="center" align="center" show-overflow-tooltip>
			<template slot-scope="scope">
				<span>{{ scope.row.sourceOrg == 'HY' ? '海茵科技' : '' }}</span>
			</template>
			</el-table-column>
				<el-table-column prop="status" label="交易状态" header-align="center" align="center">
					<template slot-scope="scope" v-if="scope.row.id!=null">
						<el-tag v-if="scope.row.status == 1" size="small" type="success">已到账
						</el-tag>
            <el-tag v-else-if="scope.row.status == 2" size="small" type="info">交易失败
						</el-tag>
						<el-tag v-else size="small" type="danger">银行处理中</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="batchId" label="流水号" show-overflow-tooltip header-align="center" align="center"></el-table-column>
				<el-table-column prop="businessDate" label="操作时间" header-align="center" align="center">
				</el-table-column>
				<el-table-column label="操作" fixed="right" header-align="center" align="center">
					<template slot-scope="scope">
						<el-button type="text" v-no-more-click size="small" @click="checkPaid(scope.row.id)" v-if="scope.row.status != 1 &&  scope.row.status != 2" style="margin: 0;">到账查询
						</el-button>
						<!-- <el-button type="text" size="small" @click="downloadHandle(scope.row.id)" v-if="scope.row.status == 1 && scope.row.businessType == 'grsk'" style="margin: 0;">
							下载回单
						</el-button> -->
						<!-- <el-button v-if="$hasPermission('user:userList:delete')" type="text" size="small"
							@click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button> -->
					</template>
				</el-table-column>
        <el-table-column prop="errtxt" v-if="cookieJue == 'OPERATE'" label="备注" header-align="center" align="center"></el-table-column>
			</el-table>
			<el-pagination background :current-page="page" :page-sizes="[10, 20, 50, 100]" :page-size="limit"
				:total="total" layout="total, sizes, prev, pager, next, jumper" @size-change="pageSizeChangeHandle"
				@current-change="pageCurrentChangeHandle"></el-pagination>
			<!-- 弹窗, 新增 / 修改 -->
			<add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
			<set-pwd v-if="setpwdVisible" ref="SetPwd" @refreshDataList="getdefaultInfo"></set-pwd>
			<set-chongzhi v-if="setczVisible" ref="setchongzhi" @refreshDataList="getdefaultInfo"></set-chongzhi>
		</div>
	</el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './plattransactiondetais-add-or-update'
import SetPwd from './plattransactiondetais-set-pwd'
import SetChongzhi from './plattransactiondetais-set-chongzhi'
import Cookies from 'js-cookie';
import uploadBtn from '../uploadBtn'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      taskList:[],
       pickerStartOptions(endTime){
                return {
                    disabledDate(time){
                        if(endTime){
                        // 拼接 00:00:00 是为了统一日期从0点开始 
                        return time.getTime() > new Date(endTime +' 00:00:00').getTime();
                        }
                    }
                } 
            },
            pickerEndOptions(startTime){
                return {
                    disabledDate(time){
                        if(startTime){
                        // 拼接 00:00:00 是为了统一日期从0点开始 
                        return time.getTime() < new Date(startTime +' 00:00:00').getTime();
                        }
                    }
                }
            },
      setpwdVisible: false,
      setczVisible: false,
      cookieJue:Cookies.get('admin_role'),
      publicPath: process.env.BASE_URL,
      options: [{
        value: '0',
        label: '本日'
      },
      {
        value: '-7',
        label: '近一周'
      },
      {
        value: '-30',
        label: '近一月'
      },
      {
        value: '-120',
        label: '近三月'
      },
      {
        value: '-180',
        label: '近半年'
      },
      {
        value: '-365',
        label: '近一年'
      }
      ],
      businessTypeOptions:[
        {value:'cz',label:'充值'},
        {value:'fwf',label:'服务费'},
        {value:'qytk',label:'企业退款'},
        {value:'grsk',label:'个人收款'},
        {value:'pttx',label:'平台提现'},
        {value:'grtx',label:'个人提现'},
        {value:'yhs',label:'个税'},
        {value:'jzs',label:'增值税'},
        {value:'zzsfjss',label:'增值税附加税'},
        {value:'bzj',label:'保证金'},
      ],
      value: '',
      uploadUrl: '/sys/plat/plattransactiondetais/importFile', // 上传附件组件传值:上传的action
      mixinViewModuleOptions: {
        getDataListURL: '/sys/plat/plattransactiondetais/page',
        getDataListIsPage: true,
        deleteURL: '/sys/plat/plattransactiondetais',
        deleteIsBatch: true,
        exportURL: '/sys/plat/plattransactiondetais/export',
        isBodyPage:true
      },
      platBodyList: [],
      dataForm: {
          payeeAccountTitle: '',
          payeeBankAccount: '',
        myAccountTitle: '',
        startDate: '',
        endDate: '',
        timeSlot: '',
        type:"",
        taskType:'',
        idCard:'',
        phone:'',
        bodyId:''
        
      },
      infodata: []
    }
  },
  components: {
    AddOrUpdate,
    uploadBtn,
    SetPwd,
    SetChongzhi
  },
	computed:{
        rolePermissions: function () {
            return Cookies.get('admin_role')
        }
    },
  methods: {
    //任务大类请求
    getDropDownData(){
                this.$http.get('sys/plat/ticketPro/page?page=1&limit=1000').then(({data:res})=>{
                    if(res.code == 0 ){
                        this.taskList = res.data.list;
                    }else{
                        this.$message.error(res.msg)
                    }
                })
                
            },
    // 重置
    regiestDataList(){
      this.dataForm = {
        payeeAccountTitle: '',
        payeeBankAccount: '',
        myAccountTitle: '',
        startDate: '',
        endDate: '',
        timeSlot: '',
        type:"",
        taskType:'',
        idCard:'',
        phone:''
      }
      this.getDataList();
    },
     businessType(row) { //映射字段方法 业务类型
        // console.log("row.checkResult", row.checkResult)
        switch (row.businessType) {
            case 'cz':
                return "充值"
            case 'zf':
                return "支付"
            case 'qytk':
                return "企业退款"
            case 'pttx':
                return "平台提现"
            case 'grtx':
                return "个人提现"
            case 'grsk':
                return "个人收款"
            case 'fwf':
                return "服务费"
            default:
                return ""
        }
    },
    // 获取数据填充数据
    updateByTimeSlot () {
      if (this.dataForm.timeSlot !== '') {
        this.dataForm.startDate = this.GetDateStr(this.dataForm.timeSlot)
        this.dataForm.endDate = this.getdataTime()
      } else {
        this.dataForm.startDate = ''
        this.dataForm.endDate = ''
      }
    },
    // 获取当前日期时间
    getdataTime () {
      var now = new Date()
      var year = now.getFullYear() // 得到年份
      var month = now.getMonth() // 得到月份
      var date = now.getDate() // 得到日期
      month = month + 1
      month = month.toString().padStart(2, '0')
      date = date.toString().padStart(2, '0')

      var defaultDate = `${year}-${month}-${date}`
      return defaultDate
    },
    // 上传成功
    backSuccess (datas) {
      this.query()
    },
    GetDateStr (days) {
      var AddDayCount = parseInt(days)
      var dd = new Date()
      dd.setDate(dd.getDate() + AddDayCount) // 获取AddDayCount天后的日期
      var y = dd.getFullYear()
      var m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1 // 获取当前月份的日期，不足10补0
      var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate() // 获取当前几号，不足10补0
      return y + '-' + m + '-' + d
    },
    // 获取我方主体列表
    getPlatBodyList () {
      this.$http
        .get('/sys/plat/body/list')
        .then(({
          data: res
        }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.platBodyList = res.data
        })
        .catch(() => {})
    },
    getdefaultInfo () {
      this.$http
        .get('/sys/account/page-data')
        .then(({
          data: res
        }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.infodata = res.data
          console.log(this.infodata)
        })
        .catch(() => {})
    },
    // 修改密码
    setpwd (type) {
      this.setpwdVisible = true
      this.$nextTick(() => {
        this.$refs.SetPwd.init()
        this.$refs.SetPwd.type = type
      })
    },
    // 充值
    chongzhiHandle () {
      this.setczVisible = true
      this.$nextTick(() => {
        this.$refs.setchongzhi.init()
      })
    },
    checkPaid (id) {
      this.$http.get('/sys/spdb/checkPaid', {
        params: {
          id: id
        }
      }).then(({
        data: res
      }) => {
        if (res.code !== 0) {
          this.$message.error(res.msg);
          this.query()
          return;
        } else {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: 2000,
            onClose: () => {
              this.query()
            }
          })
        }
      }).catch(() => {})
    },
    downloadHandle (id) {
      console.log(id)
      this.$http.get('/sys/spdb/download', {
        params: {
          id: id
        }
      }).then(({
        data: res
      }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        } else {
          window.open(res.data)
          
        }
      }).catch(() => {})
    }
  },
  created () {
    this.getDropDownData();
    this.getPlatBodyList()
    this.getdefaultInfo()
  }
}
</script>
<style lang="scss" scoped>
.transaction-record-page {
	height: calc(100vh - 80px);
	display: flex;
	flex-direction: column;
	overflow: hidden;

	::v-deep > .el-card__body {
		display: flex;
		flex-direction: column;
		height: 100%;
		padding: 10px 20px;
		overflow: hidden;
	}

	> .el-row {
		flex-shrink: 0;
	}

	.table-container {
		flex: 1;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		padding-top: 10px;

		> .el-table {
			flex: 1;
			overflow: auto;
		}

		> .el-pagination {
			flex-shrink: 0;
			padding: 0;
			text-align: right;
		}
	}
}

/deep/ .el-form--inline .el-form-item {
	margin-bottom: 9px;
}
</style>